import { Width } from "../../../../../types";

export const maxWidthMap = Object.freeze({
  large: ["100%", "900px"] as [Width, Width],
  medium: ["100%", "640px"] as [Width, Width],
  small: ["100%", "500px"] as [Width, Width]
});

export type MaxWidth = keyof typeof maxWidthMap;
